module.exports = __webpack_public_path__ + "static/media/resume.8adf4211.pdf";